export class TableCell<T> {
  constructor(
    public data: T | null,
    public position: { x: number, y: number }
  ) { }
}
